/**
 * @flow
 * @relayHash f26f465940457d1cd1bf7cd73bb034ce
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AddProcurementItemMutationVariables = {|
  userId: string;
  input: {
    action: "ADD" | "REMOVE";
    itemIds?: ?$ReadOnlyArray<?string>;
    subject?: ?string;
    message?: ?string;
    note?: ?string;
    userId: string;
    skipHoldRequest?: ?boolean;
    clientMutationId?: ?string;
  };
|};

export type AddProcurementItemMutationResponse = {|
  +modifyProcurementItems: ?{|
    +items: ?$ReadOnlyArray<?{|
      +id: string;
      +isInProcurement: ?boolean;
    |}>;
    +portfolio: ?{|
      +id: string;
      +items: ?{|
        +totalResults: ?number;
      |};
    |};
  |};
|};
*/


/*
mutation AddProcurementItemMutation(
  $userId: String!
  $input: ModifyProcurementItemsInput!
) {
  modifyProcurementItems(input: $input) {
    items {
      id
      isInProcurement(userId: $userId)
    }
    portfolio {
      id
      items(first: 1) {
        totalResults
      }
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifyProcurementItemsInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddProcurementItemMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifyProcurementItemsInput!"
          }
        ],
        "concreteType": "ModifyProcurementItemsPayload",
        "name": "modifyProcurementItems",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Item",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "name": "isInProcurement",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfolioV2",
            "name": "portfolio",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  }
                ],
                "concreteType": "PortfolioItemsConnection",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": "items{\"first\":1}"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AddProcurementItemMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ModifyProcurementItemsInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "AddProcurementItemMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ModifyProcurementItemsInput!"
          }
        ],
        "concreteType": "ModifyProcurementItemsPayload",
        "name": "modifyProcurementItems",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Item",
            "name": "items",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "name": "isInProcurement",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfolioV2",
            "name": "portfolio",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  }
                ],
                "concreteType": "PortfolioItemsConnection",
                "name": "items",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": "items{\"first\":1}"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation AddProcurementItemMutation(\n  $userId: String!\n  $input: ModifyProcurementItemsInput!\n) {\n  modifyProcurementItems(input: $input) {\n    items {\n      id\n      isInProcurement(userId: $userId)\n    }\n    portfolio {\n      id\n      items(first: 1) {\n        totalResults\n      }\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/__generated__/AddProcurementItemMutation.graphql.js